export class GdkCookies {
  constructor() {
  }

  public static get(cname: string) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  public static remove(name) {
    this.set(name, '', -1);
  }

  public static set(name: string, value: string, expireDays: number = 1, path: string = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires: string = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + '; ' + expires + (path.length > 0 ? '; path=' + path : '/');
  }

  public static clear() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      this.remove(cookies[i].split('=')[0]);
    }
  }
}
